import React from 'react';
import styled from 'styled-components';

const EducationSection = styled.section`
  padding: 5rem 0;
  background-color: ${props => props.theme.colors.primary.background};
`;

const EducationContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.h2};
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: ${props => props.theme.colors.accent.teal};
  }
`;

const EducationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const EducationCard = styled.div`
  background-color: ${props => props.theme.colors.primary.lighter};
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const SchoolLogo = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const SchoolName = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: ${props => props.theme.colors.accent.teal};
`;

const Degree = styled.h4`
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const FieldOfStudy = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: 0.5rem;
`;

const Period = styled.p`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: 1rem;
`;

const Education = () => {
  const educations = [
    {
      school: "TAFE NSW",
      degree: "Bachelor of Information Technology (Network Security)",
      field: "Information Technology",
      period: "2018 - 2020",
      logo: "https://media.licdn.com/dms/image/v2/D560BAQFuqlpWKDbZeA/company-logo_400_400/0/1714527868125/tafe_nsw_logo?e=1752710400&v=beta&t=MCwhvU5oZMB_yN7iT81CAB7AAjtX4MlB7VFt1SM6URI"
    },
    {
      school: "The Northern Sydney Institute - TAFE NSW",
      degree: "Diploma of Information Technology Networking",
      field: "Information Technology",
      period: "2014",
      logo: "https://media.licdn.com/dms/image/v2/D560BAQFuqlpWKDbZeA/company-logo_400_400/0/1714527868125/tafe_nsw_logo?e=1752710400&v=beta&t=MCwhvU5oZMB_yN7iT81CAB7AAjtX4MlB7VFt1SM6URI"
    },
    {
      school: "Western Sydney University",
      degree: "Bachelor of Information Systems",
      field: "Information Technology",
      period: "2013",
      logo: "https://media.licdn.com/dms/image/v2/C560BAQGfYhUiKW3s6w/company-logo_400_400/0/1678139810525/western_sydney_university_logo?e=1752710400&v=beta&t=bKsTt4TdJ_Yt6VwCvj2Rq9wmdk87cKy8D4l3c_u9Mv0"
    },
    {
      school: "Ku-ring-gai Creative Arts High School",
      degree: "High School Certificate",
      field: "",
      period: "2007 - 2012",
      logo: ""
    }
  ];

  return (
    <EducationSection id="education">
      <EducationContainer>
        <SectionTitle>Education</SectionTitle>
        <EducationGrid>
          {educations.map((edu, index) => (
            <EducationCard key={index}>
              {edu.logo && (
                <SchoolLogo>
                  <img src={edu.logo} alt={`${edu.school} logo`} />
                </SchoolLogo>
              )}
              <SchoolName>{edu.school}</SchoolName>
              <Degree>{edu.degree}</Degree>
              {edu.field && <FieldOfStudy>{edu.field}</FieldOfStudy>}
              <Period>{edu.period}</Period>
            </EducationCard>
          ))}
        </EducationGrid>
      </EducationContainer>
    </EducationSection>
  );
};

export default Education;
